import React, { useState, useEffect } from 'react';
import { Typography } from '@guildeducationinc/recess';
import { BookIcon } from 'src/components/Quiz/Icons/BookIcon';
import { ScreenProps } from 'src/containers/QuizContainer/types';
import styles from './LoadingResults.module.scss';

export const LoadingResults: React.FC<ScreenProps> = props => {
	const [activeQuote, setActiveQuote] = useState(0);
	const [animateIcon, setAnimateIcon] = useState(false);

	const quotes = [
		"I'm graduating with a bachelor's degree with no student debt!",
		"With Guild, having your degree isn't a dream anymore, they will make it happen. Just believe in yourself that you can do it.",
	];

	useEffect(() => {
		props.createRecs();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => setAnimateIcon(true), 1000);
		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		const timer = setTimeout(() => {
			const nextQuote = activeQuote === 0 ? 1 : 0;
			setActiveQuote(nextQuote);
		}, 5000);
		return () => clearTimeout(timer);
	}, [activeQuote]);

	return (
		<div className={styles.loadingResults} data-testid='loading-results'>
			<BookIcon animated={animateIcon} size={130} />
			<Typography role='status' variant='body2'>
				Finalizing recommendations...
			</Typography>
			<Typography className={styles.quote} variant='h1'>
				{quotes[activeQuote]}
			</Typography>
			<Typography variant='body2'>- Guild Education student</Typography>
		</div>
	);
};
